module.exports = __webpack_public_path__ + "img/front length from HPS to hem.80859d99.png";